"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Link = _interopRequireDefault(require("@sprinx/react-mui-components/Link"));

var _styles = require("@material-ui/core/styles");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _PasswordField = _interopRequireDefault(require("@sprinx/react-mui-fields/PasswordField"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));

var _FormTextField = _interopRequireDefault(require("../../components/FormTextField"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    input: {
      width: '100%',
      '& label': {
        fontWeight: 500
      }
    },
    loginBtnContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(1),
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.another.cart.borders,
      paddingBottom: theme.spacing(2)
    },
    passwordField: {
      '& legend': {
        maxWidth: 0
      }
    }
  };
}, {
  name: 'LoginFormInner'
});

var LoginFormInner = function LoginFormInner(_ref) {
  var pClasses = _ref.classes,
      errors = _ref.errors,
      isLoginError = _ref.isLoginError,
      isSubmitting = _ref.isSubmitting,
      handleChange = _ref.onChange,
      handleClose = _ref.onClose,
      handleSubmit = _ref.onSubmit,
      values = _ref.values;
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit
  }, isLoginError && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    severity: "error"
  }, t('cartFormLogin/error')), /*#__PURE__*/_react.default.createElement(_FormTextField.default, {
    autoFocus: true,
    type: "text",
    name: "username",
    id: "username",
    label: t('loginDialog/username'),
    value: values.username,
    classes: {
      root: classes.input
    },
    onChange: handleChange('username'),
    error: errors.username,
    required: true
  }), /*#__PURE__*/_react.default.createElement(_FormTextField.default, {
    Component: _PasswordField.default,
    name: "passwordLogin",
    id: "passwordLogin",
    label: t('loginDialog/password'),
    value: values.password,
    className: classes.passwordField,
    classes: {
      root: classes.input
    },
    onChange: handleChange('password'),
    error: errors.password,
    required: true
  }), /*#__PURE__*/_react.default.createElement("div", null, t('registration/dialog'), ' ', /*#__PURE__*/_react.default.createElement(_Link.default, {
    to: "/registration",
    onClick: handleClose
  }, t('registration/here'))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.loginBtnContainer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    size: "large",
    color: "secondary",
    type: "submit",
    disable: isSubmitting
  }, t('cartFormLogin/button'))));
};

process.env.NODE_ENV !== "production" ? LoginFormInner.propTypes = {
  classes: _propTypes.default.shape({
    dialog: _propTypes.default.string,
    input: _propTypes.default.string,
    loginBtnContainer: _propTypes.default.string,
    loginButton: _propTypes.default.string,
    passwordField: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  errors: _propTypes.default.shape({
    password: _propTypes.default.string,
    username: _propTypes.default.string
  }),
  isLoginError: _propTypes.default.bool.isRequired,
  isSubmitting: _propTypes.default.bool.isRequired,
  onChange: _propTypes.default.func.isRequired,
  onClose: _propTypes.default.func.isRequired,
  onSubmit: _propTypes.default.func.isRequired,
  values: _propTypes.default.shape({
    password: _propTypes.default.string,
    username: _propTypes.default.string
  }).isRequired
} : void 0;
LoginFormInner.defaultProps = {
  classes: undefined,
  errors: {}
};
var _default = LoginFormInner;
exports.default = _default;